import { baseUrl, headers } from 'api';

export const getEndereco = async (params) => {
  const response = await fetch(`${baseUrl}/curriculo/endereco/${params || ''}`, {
    method: 'GET',
    headers: {
      ...headers,
      Authorization: sessionStorage.getItem('@senac:token'),
    },
  });

  return response;
};
